import { render, staticRenderFns } from "./invoiceHistory.vue?vue&type=template&id=37316f54&scoped=true&"
import script from "./invoiceHistory.vue?vue&type=script&lang=js&"
export * from "./invoiceHistory.vue?vue&type=script&lang=js&"
import style0 from "./invoiceHistory.vue?vue&type=style&index=0&id=37316f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37316f54",
  null
  
)

export default component.exports